export const dosage = {
  takeWith: "Take with",
  takeWithInstruction: "Take with {{ takeWith }}",
  emptyStomachInstruction: "Take on an empty stomach",
  takeWithPill: "With {{ takeWith }}",
  reasonForTaking: "Reason for taking",
  reasonForTakingInstruction: "For <strong>{{ reasonForTaking }}</strong>",
  takeForReasonInstruction: "Take for {{ reasonForTaking }}",
  notSelected: "Not selected",
  dosageNonNumeric: "Dosage must be numeric",
  serving: " serving",
  serving_plural: " servings",
  additionalNotes: "Additional notes",
  dosageAmount: "Dosage amount: ",
  whenToTake: "When to take: ",
  duration: "Duration: ",
  productDosage: "{{ dosageAmount }} {{ dosageFormat }} {{ dosageFrequency}}",
  productDosageNoFrequency: "{{ dosageAmount }} {{ dosageFormat }}",
  dosageWithTakeWith: "{{ dosage }}. {{ takeWithText }}",

  // "Take with" options
  food: "Food",
  water: "Water",
  emptyStomach: "Empty stomach",

  // Frequency
  frequency: "Frequency",
  oncePerDay: "Once per day",
  twicePerDay: "Twice per day",
  threeTimesPerDay: "Three times per day",
  fourTimesPerDay: "Four times per day",
  fiveTimesPerDay: "Five times per day",
  asNeeded: "As needed",
  anytimeFrequency: "{{frequency}} (Anytime)",

  // Time of day
  anytime: "Anytime",
  uponWaking: "Upon waking",
  morning: "Morning",
  afternoon: "Afternoon",
  evening: "Evening",
  bedtime: "Bedtime",
} as const;
